import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, OfficialDailyReducer, OfficialDailyState } from './official-daily-reducer';
import { Pagination } from '../../../model/paginatiion';
import { IOfficialDailyResponse } from '../../../model/base/response/official-daily-response';

const OfficialDailyContext = createContext<OfficialDailyState | undefined>(undefined);
const OfficialDailyContextDispatchContext = createContext({} as any);

const OfficialDailyProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: OfficialDailyState = {
        officialDaily: new Pagination<IOfficialDailyResponse>(),
        loading: false,
    };

    const [state, dispatch] = useReducer(OfficialDailyReducer, initialState);

    return (
        <OfficialDailyContext.Provider value={state}>
            <OfficialDailyContextDispatchContext.Provider value={dispatch}>
                {children}
            </OfficialDailyContextDispatchContext.Provider>
        </OfficialDailyContext.Provider>
    );
}

const useOfficialDailyState = () => {
    const context = useContext(OfficialDailyContext);
    if (context === undefined) {
        throw new Error('useOfficialDailyState must be used within a OfficialDailyProvider');
    }
    return context;
}

const useOfficialDailyDispatch = () => {
    const context = useContext(OfficialDailyContextDispatchContext);
    if (context === undefined) {
        throw new Error('useOfficialDailyDispatch must be used within a OfficialDailyProvider');
    }
    return context;
}

export { OfficialDailyProvider, useOfficialDailyState, useOfficialDailyDispatch, ACTION_TYPES };
